/**
 * Normalize a typed phone number into the E.164 form Person.phones and
 * Message's *_number fields already use, so a typed number compares against
 * them with plain equality — no fuzzy matching needed either way.
 *
 * A bare 10-digit number is read as a US number (+1), per the brief. Anything
 * already carrying a "+", or an 11-digit number starting with 1, is kept as
 * given. Anything else is not a phone number this app can send to.
 */
export function normalizePhone(raw) {
  if (!raw) return null;
  const trimmed = String(raw).trim();
  if (trimmed.startsWith("+")) {
    const digits = trimmed.slice(1).replace(/\D/g, "");
    return digits.length >= 8 ? `+${digits}` : null;
  }
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return null;
}

export function formatPhone(e164) {
  if (!e164) return "";
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  if (m) return `(${m[1]}) ${m[2]}-${m[3]}`;
  return e164;
}
